import {
  api
} from '@/api/index.js';
import {
  store
} from '../index';
import {
  library
} from "@/assets/js/library.js";

const actions = {
  readeFeeds(commit, params) {
    return api.readeFeeds(params.taskid, params.fedid, params.direction, params.type, params.searchingstring, params.fed_important, params.fedtime, params.impbyoth).then(response => {
      store.commit('addMessages', {
        'direction': params.direction,
        'data': response.data.data
      });
      return response;
    });
  },
  readeGloablFeeds(commit, params) {
    return api.readeGloablFeeds(params.offset, params.type, params.searchingstring, params.fed_important, params.impbyoth);
  },
  async sendAttach(commit, params) {
    await api.sendAttach(params.taskid, params.file);
    let msg = state.messages;
    if (msg.length === 0) {
      store.dispatch("readeFeeds", {
        taskid: params.taskid,
        fedid: 0,
        direction: "start"
      });
    } else {
      store.dispatch("readeFeeds", {
        taskid: params.taskid,
        fedid: msg[msg.length - 1].fed_id,
        direction: "down"
      });
    }
  }
};

const mutations = {
  addMessages: (state, params) => {
    if (params.data) {
      if (params.direction === 'start') {
        state.scrollDownMess = true;
        state.messages = params.data;
      } else if (params.direction === 'up') {
        state.scrollDownMess = false;
        for (let i = params.data.length - 1; i >= 0; i--) {
          if (!library.messagesHaveFeed(state.messages, params.data[i]))
            state.messages.unshift(params.data[i]);
        }
      } else if (params.direction === 'down') {
        state.scrollDownMess = true;
        if (params.data != undefined)
          for (let i = 0; i < params.data.length; i++) {
            if (!library.messagesHaveFeed(state.messages, params.data[i]))
              state.messages.push(params.data[i]);
          }
      }
    }
  },
  clearFeed: (state) => {
    state.messages = [];
  },
  changeImportant: (state, params) => {
    let fed_id = params.mess.fed_id;
    for (let i in state.messages) {
      let message = state.messages[i];
      if (message.fed_id == fed_id) {
        message.fed_important = !message.fed_important;
        api.setFeedImportant(message.fed_id, message.fed_important);
      }
    }
  },
  setSelectedStep: (state, params) => {
    state.selectedStep = params;
  },
};

const state = {
  messages: [],
  scrollDownMess: true,
  selectedStep: null,
};

export default {
  actions,
  mutations,
  state
};



// WEBPACK FOOTER //
// ./src/store/modules/feed.js